<div class="gray-bg-rounded">
  <div class="col-lg-12 sidepanel-box">
    <div class="row">
      <div class="calender-sidepanel">
        <p-datePicker [inline]="true" [showWeek]="true"></p-datePicker>
        <div class="today-task">
          <div
            class="d-flex justify-content-between topboder mt-3 mb-2 pb-2 globalborder-btm-header">
            <span class="d-flex justify-content-between gap-2 align-items-top">
              <span><i class="pi pi-clipboard"></i></span>
              <h2 class="mb-0">
                Today's Tasks
                <jni-spinner *ngIf="showSmallLoader"></jni-spinner>
              </h2>
            </span>
            <span
              ><a (click)="showDialog()" class="text-decoration-none"
                >Upcoming</a
              ></span
            >
          </div>

          <div
            *ngIf="!showSmallLoader && todaysTask.length > 0; else noList"
            class="box-height">
            <div
              *ngFor="let item of todaysTask"
              class="col-lg-12 today-list-bar gray-bg">
              <div class="col-lg-12 mb-3 pb-1 globalborder-btm-header">
                <p class="mb-1 mt-1">{{ item.title }}</p>
              </div>
              <div class="d-flex gap-2 align-items-center">
                <p class="icon-box m-0"><i class="pi pi-clock"></i></p>
                <p class="time-bar m-0">{{ item.dueDate | date }}</p>
              </div>
            </div>
          </div>

          <ng-template #noList>
            <div class="col-lg-12 today-list-bar gray-bg">
              <div class="lds-ring inline me-auto ms-2" *ngIf="showSmallLoader">
                <div></div>
                <div></div>
                <div></div>
              </div>
              <h3 *ngIf="!showSmallLoader" class="mt-3">
                No tasks available for today.
              </h3>
            </div>
          </ng-template>
        </div>
      </div>
    </div>
  </div>
</div>
<p-dialog
  [(visible)]="display"
  [style]="{ width: '60%', height: '70%', maxHeight: '100%' }"
  appendTo="body">
  <div class="col-lg-12">
    <div class="position-relative">
      <div class="has-border2 pb-2 mb-4 position-fixed position-heading">
        <h1>Upcoming Tasks</h1>
      </div>
    </div>
    <div class="mt-4 spacer"></div>
    <div class="col-12 mb-4 mt-3">
      <p-table
        [value]="upcomingTask"
        styleClass="p-datatable-customers ordersListing search-more"
        [rows]="pageSize"
        [showCurrentPageReport]="true"
        [paginator]="true"
        [filterDelay]="1"
        (onPage)="pageChange($event)"
        [lazy]="true"
        (onLazyLoad)="getUsersUpcomingTaskList()"
        [totalRecords]="totalRecords">
        <ng-template pTemplate="header">
          <tr>
            <th>Task Name</th>
          </tr>
        </ng-template>
        <ng-template pTemplate="body" let-task>
          <tr>
            <td>
              {{ task.title }}
              <p>{{ task.dueDate | date: "medium" }}</p>
            </td>
          </tr>
        </ng-template>
      </p-table>
    </div>
  </div>
</p-dialog>
